import { render, staticRenderFns } from "./ExtIntro.vue?vue&type=template&id=008e3634&scoped=true&"
import script from "./ExtIntro.vue?vue&type=script&lang=js&"
export * from "./ExtIntro.vue?vue&type=script&lang=js&"
import style0 from "./ExtIntro.vue?vue&type=style&index=0&id=008e3634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008e3634",
  null
  
)

export default component.exports